/**
 * View component for /user-answers
 *
 * Generic userAnswer list view. Defaults to 'all' with:
 * this.props.dispatch(userAnswerActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userAnswerActions from '../userAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userAnswer components
import UserAnswerLayout from '../components/UserAnswerLayout.js.jsx';
import UserAnswerListItem from '../components/UserAnswerListItem.js.jsx';

// import userAnswer css modules
import userAnswerStyles from '../userAnswerModuleStyles.css';

class UserAnswerList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(userAnswerActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { userAnswerStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the userAnswerList meta info here so we can reference 'isFetching'
    const userAnswerList = userAnswerStore.lists ? userAnswerStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual userAnswer objetcs
     */
    const userAnswerListItems = userAnswerStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !userAnswerListItems || !userAnswerList;

    return (
      <UserAnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> User Answer List
                <Link className="yt-btn small u-pullRight" to={'/user-answers/new'}> NEW User Answer </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (userAnswerListItems && userAnswerList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userAnswerList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {userAnswerListItems.map((userAnswer, i) =>
                      <UserAnswerListItem key={userAnswer._id + i} userAnswer={userAnswer} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </UserAnswerLayout>
    )
  }
}

UserAnswerList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userAnswerStore: store.userAnswer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserAnswerList)
);



// WEBPACK FOOTER //
// modules/userAnswer/views/UserAnswerList.js.jsx